import React from 'react';
import { Box, Typography } from '@mui/material';

// Shared design tokens for the Add Client wizard (WhatsApp-green accent)
export const C = {
  card:        '#ffffff',
  cardBorder:  '#e2e8f0',
  ink:         '#1e293b',
  sub:         '#64748b',
  muted:       '#94a3b8',
  headerBg:    '#f8fafc',
  primary:     '#128C7E',
  primarySoft: '#dcf8c6',
};

// Shared rounded-input styling applied to every TextField / Select / Autocomplete
export const fieldSx = {
  '& .MuiOutlinedInput-root': { borderRadius: '10px' },
};

export const yesNoLabelSx = { fontSize: '0.8rem', fontWeight: 600, color: C.sub, mb: 0.5 };

export const SectionCard: React.FC<{ title: string; icon?: React.ReactNode; children: React.ReactNode | React.ReactNode[] }> = ({ title, icon, children }) => (
  <Box
    sx={{
      border: `1px solid ${C.cardBorder}`,
      borderRadius: '14px',
      bgcolor: C.card,
      p: { xs: 2, sm: 2.5 },
      mb: 2,
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 2 }}>
      {icon && (
        <Box
          sx={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            width: 34, height: 34, borderRadius: '10px',
            bgcolor: C.primarySoft, color: C.primary, flexShrink: 0,
          }}
        >
          {icon}
        </Box>
      )}
      <Typography variant="subtitle1" fontWeight={700} sx={{ color: C.ink }}>{title}</Typography>
    </Box>
    {children}
  </Box>
);
